import * as Sentry from '@sentry/nextjs'

export const TENANT_TAG = 'tenant_id'

export function setTenantContext(tenantId: string | null | undefined): void {
  Sentry.setTag(TENANT_TAG, tenantId && tenantId.length > 0 ? tenantId : 'unknown')
}

export function clearTenantContext(): void {
  Sentry.setTag(TENANT_TAG, 'unknown')
}
